import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { UPDATE_STAFF_PIN } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import { id } from "intl-tel-input/i18n";

const ModalChangePIN = ({
  hidden,
  buttonStyle,
  staffId
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [currentPINEntered, setCurrentPINEntered] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);
  const [currentPIN, setCurrentPIN] = useState("");
  const [newPIN, setNewPIN] = useState("");
  const [PINError, setPINError] = useState(false);

  const [updateStaffPIN, { loading }] = useMutation(UPDATE_STAFF_PIN, {
    onCompleted: () => {
      setIsOpen(false);
      setFailedIsOpen(false);
      setCurrentPIN("");
      setNewPIN("");
    },
    onError: () => {
      setIsOpen(false);
      setFailedIsOpen(true);
    }
  });

  const handleContinue = () => {
    if (currentPIN.trim() === "" || currentPIN.length !== 6) {
      setPINError(true);
      return;
    }
    setCurrentPINEntered(true);
  };

  const handleChangePIN = () => {
    if (loading) return;
    if (newPIN.trim() === "" || newPIN.length !== 6) {
      setPINError(true);
      return;
    }
    updateStaffPIN({
      variables: {
        staffId: staffId, 
        input: {
          currentPin: currentPIN,
          pin: newPIN
        }
      }
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Change PIN"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>
          {currentPINEntered ? "Enter New PIN" : "Enter Current PIN"}
        </Head>
        <Container>
          {currentPINEntered? <Input
            title="6-DIGIT PIN"
            required
            type="number"
            error={PINError}
            errorMessage="Please enter a valid PIN"
            value={newPIN}
            onChange={(e) => {
              const val = e.target.value;
              // Only update if the length is 6 or less
              if (val.length <= 6) {
                setNewPIN(e.target.value);
                setPINError(false);
              }
            }}
            additionalstyle={`
            width: 100%;
          `}
          />: <Input
            title="6-DIGIT PIN"
            required
            type="number"
            error={PINError}
            errorMessage="Please enter a valid PIN"
            value={currentPIN}
            onChange={(e) => {
              const val = e.target.value;
              // Only update if the length is 6 or less
              if (val.length <= 6) {
                setCurrentPIN(val);
                setPINError(false);
              }
            }}
            additionalstyle={`
            width: 100%;
          `}
          />}
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={currentPINEntered ? handleChangePIN : handleContinue}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setClose={()=> {
          setCurrentPIN("");
          setNewPIN("");
          setCurrentPINEntered(false);
          setFailedIsOpen(false);
        }}
        loading={loading}
        retryFunction={handleChangePIN}
        type="changePIN"
      />
    </>
  );
};

export default ModalChangePIN;